import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { PostHogWrapper } from './components/PostHogWrapper';
import { LicenseInfo } from "@mui/x-license";

// Call setLicenseKey() before React renders the first component.
// Designed to be public: https://mui.com/x/introduction/licensing/#license-key-security
LicenseInfo.setLicenseKey(
	'b09ca334a6b2d0fb6a6ca0206b5ab27fTz0xMTg5MzAsRT0xNzg5MTcxMTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y'
);


const container = document.getElementById('root');
const root = createRoot(container);

root.render(
	<React.StrictMode>
		<PostHogWrapper>
			<App />
		</PostHogWrapper>
	</React.StrictMode>
);
